<template>
  <span class="CreateplusMessage"  v-if="createplusMessages" v-html="getLabel(fcontId,flinkId,msgkey,defaultValue)"></span>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: 'CreateplusMessage',
  props: {
    fcontId: String,
    flinkId: String,
    msgkey: String,
    defaultValue: String
  },
  computed: {
    ...mapState("createplusMessages", ["createplusMessages"])
  },
  methods: {
    getLabel : function (contId, linkId, key, defaultValue) {
      if(this.createplusMessages !== undefined){
        return this.createplusMessages[contId + '-' + linkId + '-' + key] || (defaultValue == null ? "" : defaultValue);
      }
      return "";
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>